// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconWineBottle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M14 21V9.737a3.01 3.01 0 00-1.336-2.504A4.5 4.5 0 0111.5 6.101a4.5 4.5 0 01-1.164 1.132A3.01 3.01 0 009 9.737V21zM9.222 5.572A5.01 5.01 0 007 9.737V21a2 2 0 002 2h5a2 2 0 002-2V9.737a5.01 5.01 0 00-2.222-4.165 2.5 2.5 0 01-1.111-2.083V1h-2.334v2.49c0 .835-.416 1.616-1.11 2.082"
    />
  );
export default SvgIconWineBottle;
